import RemoteSelect from 'common/components/RemoteSelect/RemoteSelect';
import { Department } from 'types/Department';

const processOptions = (options: Department[]) =>
  options.map(({ id, name, CP }) => ({
    value: id,
    label: `${String(CP).padStart(2, '0')} - ${name}`,
  }));

function DepartmentSelect(props: any) {
  const { excludeIds } = props;

  const filters = excludeIds ? [{ name: 'id][$notIn', value: excludeIds }] : [];
  const sort = 'CP:asc';

  return (
    <RemoteSelect
      url="departments"
      processOptions={processOptions}
      filters={filters}
      sort={sort}
      {...props}
    />
  );
}

export default DepartmentSelect;
